<header
  [ngClass]="{ open: navbarExpanded(), fixed: isHeaderFixed() }"
  (mouseleave)="navbarFocusedDesktop.set(false)"
  class="app-he"
>
  <nav
    [ngClass]="{ open: navbarExpanded(), scrolled: isHeaderFixed() }"
    class="app-he__nav"
    (mouseleave)="cartActive.set(false)"
  >
    <div class="app-he__nav__wrap navbar navbar-expand-md" [ngClass]="{ 'app-he__nav__wrap__border': border() }">
      <div [ngClass]="{ show: navbarExpanded() }" class="navbar-collapse collapse d-none d-md-block">
        <ul class="navbar-nav text-center text-xl-left">
          <li class="nav-item">
            <a
              (click)="navbarFocusedDesktop.set(true); navbarExtContentActive.set(categories)"
              (mouseover)="navbarFocusedDesktop.set(true); navbarExtContentActive.set(categories)"
              class="nav-link"
              >O PRO.CONNECT</a
            >
          </li>
          <li class="nav-item">
            <a
              (click)="navbarFocusedDesktop.set(true); navbarExtContentActive.set(brands)"
              (mouseover)="navbarFocusedDesktop.set(true); navbarExtContentActive.set(brands)"
              class="nav-link"
              >{{ user() ? 'ZAPISY NA SZKOLENIA' : 'NASZE MARKI' }}
            </a>
          </li>
        </ul>
      </div>

      <a
        [routerLink]="user() ? ['/' + WwwRouteSlug.ACCOUNT] : ['/']"
        (click)="logoClick()"
        class="app-he__nav--logo"
        appGtmClick
        [layer]="{
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'main menu navigation',
          eventAction: 'select',
          eventLabel: 'logo',
          event_name: 'logo_click',
        }"
      >
        <img
          ngSrc="assets/images/pro-connect-black.svg"
          [priority]="true"
          alt="logo"
          class="d-block w-100 h-auto"
          height="14"
          width="140"
        />
      </a>

      @if (user()) {
        <button
          (click)="
            navbarExpanded.set(false);
            cartActive.set(true);
            navbarExtContentActive.set(null);
            navbarFocusedDesktop.set(false);
            pushLayer('cart', 'header')
          "
          class="app-he__nav__wrap--cart"
          title="cart"
          type="button"
        >
          @if (accountOrders()?.length) {
            <div class="count">{{ accountOrders()?.length }}</div>
          }
          <img src="assets/images/cart.svg" />
        </button>
      }

      <button
        (click)="toggleNavbar()"
        [ngClass]="{ collapsed: !navbarExpanded() }"
        (click)="pushLayer('', 'burger menu', 'select::burger')"
        class="app-he__nav__wrap--toggle navbar-toggler ml-auto"
        title="toggle"
        type="button"
      >
        <span [ngClass]="{ expanded: navbarExpanded() }" class="app-he__nav__wrap--toggle--icon">
          <span class="top"></span>
          <span class="center"></span>
          <span class="bottom"></span>
        </span>
      </button>

      <!-- @if (user()) {
        <div
          ngbDropdown
          class="d-none d-md-inline-block app-he__nav__wrap--profile"
          [autoClose]="true"
          #drop="ngbDropdown"
          (mouseenter)="drop.open()"
          (mouseleave)="drop.close()"
        >
          <button type="button" id="dropdownBasic1" ngbDropdownToggle>
            <img src="assets/images/menu/profile.png" />
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <a ngbDropdownItem (click)="navbarExpanded.set(false); logout()" class="nav-link">WYLOGUJ</a>
          </div>
        </div>
      } -->

      <div [ngClass]="{ show: navbarExpanded() }" class="navbar-collapse collapse justify-content-md-end">
        <ul class="navbar-nav" [ngClass]="{ 'navbar-nav--pro': user() }">
          <li class="nav-item d-md-none">
            <div class="row">
              <div class="col-12">
                <a
                  class="nav-link"
                  (click)="navbarExtContentActive.set(navbarExtContentActive() === categories ? null : categories)"
                  >O PRO.CONNECT
                  <!-- <span class=>
                    
                  </span> -->
                  <svg
                    class="arrow"
                    [ngClass]="{ closed: navbarExtContentActive() === categories }"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path
                      d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
                    />
                  </svg>
                </a>
              </div>
            </div>

            @if (navbarExtContentActive() === categories) {
              <ng-container *ngTemplateOutlet="navbarExtContentActive(); context: { direction: 'column' }" />
            }
          </li>
          <li class="nav-item d-md-none">
            <div class="row">
              <div class="col-12 col-md-6">
                <a
                  (click)="navbarExtContentActive.set(navbarExtContentActive() === brands ? null : brands)"
                  class="nav-link"
                  >{{ user() ? 'ZAPISY NA SZKOLENIA' : 'NASZE MARKI' }}
                  <svg
                    class="arrow"
                    [ngClass]="{ closed: navbarExtContentActive() === brands }"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                    <path
                      d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
                    />
                  </svg>
                </a>
              </div>
            </div>

            @if (navbarExtContentActive() === brands) {
              <ng-container *ngTemplateOutlet="navbarExtContentActive(); context: { direction: 'column' }" />
            }
          </li>
          @if (!user()) {
            <li class="nav-item d-md-none">
              <a
                class="nav-link"
                [routerLink]="['/' + WwwRouteSlug.PRO_EXPERIENCE]"
                (click)="pushLayer('pro-experience', 'header')"
                >BIZNES</a
              >
            </li>
          }
          @if (user()) {
            <li class="nav-item">
              <a
                (click)="
                  navbarExpanded.set(false);
                  cartActive.set(true);
                  navbarExtContentActive.set(null);
                  navbarFocusedDesktop.set(false)
                "
                (mouseenter)="cartActive.set(true); navbarExtContentActive.set(null); navbarFocusedDesktop.set(false)"
                class="nav-link"
                >KOSZYK {{ accountOrders().length > 0 ? '(' + accountOrders().length + ')' : '' }}</a
              >
            </li>
            <li class="nav-item">
              <a
                (click)="navbarExpanded.set(false)"
                [routerLink]="['/', WwwRouteSlug.ACCOUNT, WwwRouteSlug.MY_DATA]"
                (click)="pushLayer('account::my-data', 'header')"
                class="nav-link"
                >MOJE KONTO</a
              >
            </li>

            <li class="nav-item">
              <a
                (click)="navbarExpanded.set(false); logout()"
                class="nav-link"
                (click)="pushLayer('pro-experience', 'header')"
                >WYLOGUJ</a
              >
            </li>
          } @else {
            <!-- <li class="nav-item">
              <a (click)="navbarExpanded.set(false)" [routerLink]="['/', WwwRouteSlug.LOGIN]" class="nav-link"
                >ZNAJDŹ SALON</a
              >
            </li> -->
            <li class="nav-item">
              <a
                (click)="navbarExpanded.set(false)"
                [routerLink]="['/', WwwRouteSlug.LOGIN]"
                class="nav-link"
                (click)="pushLayer('login', 'header')"
                >LOGOWANIE</a
              >
            </li>
          }
        </ul>
      </div>
    </div>
    @if (cartActive()) {
      <div class="app-he__nav__cart" [appAnimate]="'fadeInDown'" [speed]="'fast'">
        <a class="app-he__nav__cart__close d-block d-md-none" (click)="cartActive.set(false)">x zamknij okno</a>
        <app-header-cart [accountOrders]="accountOrders()" />
      </div>
    }
  </nav>
  @if (navbarFocusedDesktop()) {
    <nav class="app-he__nav-ext">
      <div class="app-he__nav-ext__con" [appAnimate]="'fadeInUp'" [speed]="'fast'">
        <div class="app-he__nav-ext__con__item"></div>

        <ng-container *ngTemplateOutlet="navbarExtContentActive(); context: { direction: 'row' }"></ng-container>
      </div>
    </nav>
  }
</header>

<ng-template #categories let-direction="direction">
  <ng-container (mouseleave)="navbarExtContentActive.set(null)">
    <button
      [routerLink]="[user() ? '/' + WwwRouteSlug.ACCOUNT : '/', WwwRouteSlug.PRO_EXPERIENCE]"
      (click)="pushLayer('account::pro-experience', 'header')"
      class="app-he__nav-ext__con__item"
      role="button"
    >
      <h3 class="app-he__nav-ext__con__item__tit"><strong>PRO:EXPERIENCE</strong></h3>
      <p class="app-he__nav-ext__con__item__desc">
        <b>Pakiet doświadczeń</b><br /><br />

        Od podróży po eventy networkingowe. Poznaj trendy i zainspiruj się pracą z profesjonalistami z całego świata.
      </p>
    </button>

    <button
      [routerLink]="[user() ? '/' + WwwRouteSlug.ACCOUNT : '/', WwwRouteSlug.PRO_EDUCATION]"
      (click)="pushLayer('account::pro-education', 'header')"
      class="app-he__nav-ext__con__item"
      role="button"
    >
      <h3 class="app-he__nav-ext__con__item__tit"><strong>PRO:EDUCATION</strong></h3>
      <p class="app-he__nav-ext__con__item__desc">
        <b>Kompleksowa edukacja​</b><br /><br />

        Nowoczesne szkolenia dostosowane do potrzeb osób zarządzających salonami fryzjerskimi, które chcą stale rozwijać
        usługi i biznes.
      </p>
    </button>

    <button
      [routerLink]="user() ? ['/', WwwRouteSlug.ACCOUNT, WwwRouteSlug.MY_DATA] : ['/', WwwRouteSlug.PRO_SUPPORT]"
      (click)="pushLayer('account::my-data', 'header')"
      class="app-he__nav-ext__con__item"
      role="button"
    >
      <h3 class="app-he__nav-ext__con__item__tit"><strong>PRO:SUPPORT</strong></h3>
      <p class="app-he__nav-ext__con__item__desc">
        <b>Zasoby do rozwoju biznesu</b><br /><br />

        Pełne wsparcie w obszarze materialnym oraz szkoleniowym. Od ofert na sprzęt fryzjerskich, przez inwestycje
        salonowe po zniżki do partnerów.
      </p>
    </button>
  </ng-container>
</ng-template>

<ng-template #brands let-direction="direction">
  <ng-container (mouseleave)="navbarExtContentActive.set(null)">
    <button
      [routerLink]="['/' + WwwRouteSlug.BRAND, Brand.LOREAL_PROFESSIONNEL]"
      (click)="pushLayer('brand::loreal-professionnel', 'header')"
      class="app-he__nav-ext__con__item"
    >
      <img alt="loreal" class="app-he__nav-ext__con__item__logo" src="assets/images/loreal.png" />
      <h3 class="app-he__nav-ext__con__item__tit d-block d-md-none"><strong>L’Oréal PROFESSIONNEL PARIS</strong></h3>
      <p class="app-he__nav-ext__con__item__desc">
        Wiodąca na świecie, ikoniczna marka dla stylistów fryzur współpracująca z ponad 1,5 mln fryzjerów na całym
        świecie.
        <span class="d-none d-md-inline"
          >Oferuje profesjonalną edukację w koloryzacji, pielęgnacji i stylizacji, współpracując z uznanymi światowymi
          ekspertami. Wspiera fryzjerów w budowaniu pewności siebie i doskonaleniu rzemiosła, umożliwiając osiąganie
          mistrzowskiego poziomu.</span
        >
      </p>
    </button>

    <button
      [routerLink]="['/' + WwwRouteSlug.BRAND, Brand.KERASTASE]"
      (click)="pushLayer('brand::kerastase', 'header')"
      class="app-he__nav-ext__con__item"
    >
      <img alt="kerastase" class="app-he__nav-ext__con__item__logo" src="assets/images/kerastase.svg" />
      <h3 class="app-he__nav-ext__con__item__tit d-block d-md-none"><strong>KERASTASE</strong></h3>
      <p class="app-he__nav-ext__con__item__desc">
        Luksusowa marka znana ze swojego innowacyjnego podejścia do piękna i zdrowia włosów.
        <span class="d-none d-md-inline">
          Od ponad 60 lat buduje swoją reputację, oferując wyjątkową, luksusową pielęgnację– wspieraną nauką w
          połączeniu z profesjonalnym doświadczeniem najlepszych fryzjerów na świecie. Kérastase zapewnia wszystkim
          wymagającym włosom wysokiej jakości, spersonalizowane, luksusowe rozwiązania pielęgnacyjne.</span
        >
      </p>
    </button>

    <button
      [routerLink]="['/' + WwwRouteSlug.BRAND, Brand.REDKEN]"
      (click)="pushLayer('brand::redken', 'header')"
      class="app-he__nav-ext__con__item"
    >
      <img alt="redken" class="app-he__nav-ext__con__item__logo" src="assets/images/redken.svg" />
      <h3 class="app-he__nav-ext__con__item__tit d-block d-md-none"><strong>REDKEN</strong></h3>
      <p class="app-he__nav-ext__con__item__desc">
        Amerykańska marka profesjonalna oferująca kultowe formuły, innowacyjne technologie i wsparcie dla stylistów
        bazując na nauce i technologii proteinowej, nawilżeniu oraz kwasowym pH.
        <span class="d-none d-md-inline"
          >Łączy nowatorskie technologie z praktycznymi warsztatami, edukacją, wspierając fryzjerów w rozwijaniu
          umiejętności w zakresie koloryzacji, stylizacji i pielęgnacji włosów.</span
        >
      </p>
    </button>

    @if (user()) {
      <button
        [routerLink]="[user() ? '/' + WwwRouteSlug.ACCOUNT : '/', WwwRouteSlug.PRO_EDUCATION]"
        (click)="pushLayer('account::pro-education', 'header')"
        class="app-he__nav-ext__con__item special"
      >
        <!-- <img alt="loreal" class="app-he__nav-ext__con__item__logo" src="assets/images/loreal.svg" /> -->
        <h3 class="app-he__nav-ext__con__item__tit app-he__nav-ext__con__item__tit__as-logo">BIZNES I ROZWÓJ</h3>
        <p class="app-he__nav-ext__con__item__desc">
          ​ Nowoczesne szkolenia dostosowane do potrzeb osób zarządzających salonami fryzjerskimi, które chcą stale
          rozwijać usługi i biznes.
        </p>
      </button>
    }
  </ng-container>
</ng-template>
